import { OutlinedTextFieldProps, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { memo, useCallback } from 'react';
import { KColors } from 'uikit';

interface IInput extends OutlinedTextFieldProps {
  pattern?: RegExp;
}

const styles = {
  root: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: KColors.primary.normal
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: KColors.primary.normal
    }
  },
  warning: {
    '& .MuiFormLabel-root.Mui-error': {
      color: KColors.warning.normal
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: KColors.warning.normal
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: KColors.warning.normal
    }
  }
};

const useStyles = makeStyles(styles);

const Input = memo((props: IInput) => {
  const { pattern, isWarning, onChange, ...otherProps } = props;

  const classes = useStyles();

  const _onChange = useCallback(
    e => {
      let event = e;
      if (pattern) {
        let v = e.target.value;
        if (v) {
          v = v.replace(pattern, '');
          event.target.value = v;
        }
      }
      onChange?.(event);
    },
    [onChange, pattern]
  );

  return (
    <TextField
      className={clsx(classes.root, { [classes.warning]: Boolean(isWarning) })}
      autoComplete="off"
      variant="outlined"
      size="small"
      id={otherProps.name}
      onChange={_onChange}
      {...otherProps}
    />
  );
});

export { Input };
